
class SupportOrdersIteratorPaginatedCollection
  constructor: (ordersFilter) ->
    @ordersFilter = ordersFilter
    @size = 10
    @resetIterator()
    @pagesRead = 0

  resetIterator: () ->
    @currentOrdersOffset = 0
    @state = "NOT_STARTED"

  resetState: () ->
    @state = "NOT_STARTED"

  hasNext: () ->
    if @isStateNotStarted()
      return true
    else if @isOrderCallQueued()
      return false
    else if @hasOrderCallFailed()
      return false
    else if @currentOrdersOffset < @getNumberOfOrdersFetched()
      return true
    else if ( (@pagesRead * @size) >= @getTotalNumberOfGroupons() )
      return false
    return true

  next: (sucessCallback, errorCallback) ->
    if @hasNext()
      _sucessCb = () =>
        @state = "SUCCESS"
        offset = @currentOrdersOffset
        @currentOrdersOffset = Math.min(@currentOrdersOffset + @size, @getNumberOfOrdersFetched())
        sucessCallback(@ordersFilter.sortedOrders.slice(offset, (offset + @size)))

      if(@currentOrdersOffset < @getNumberOfOrdersFetched())
        _sucessCb()
      else
        options =
          limit: 10
          page: @pagesRead

        _errorFilterCb = () =>
          @state = "ERROR"
          errorCallback()
        _sucessFilterCb = () =>
          @pagesRead++
          _sucessCb()

        @state = "QUEUED"
        @ordersFilter.getOrders(options, _sucessFilterCb, _errorFilterCb)

  isStateNotStarted: () ->
    @state is "NOT_STARTED"

  isOrderCallQueued: () ->
    @state is "QUEUED"

  hasOrderCallFailed: () ->
    @state is "ERROR"

  getTotalNumberOfGroupons: () ->
    if @ordersFilter.pagination
      return @ordersFilter.pagination.count
    else
      return 0

  getNumberOfOrdersFetched: () ->
    @ordersFilter.sortedOrders.length

  getNumberOfItemPerPage: () ->
    @size

  isOrdersInfoValid: () ->
    not( @isStateNotStarted() ||  (@hasOrderCallFailed() && @getNumberOfOrdersFetched() is 0) )

module.exports = SupportOrdersIteratorPaginatedCollection
